module.exports = __webpack_public_path__ + "img/radial-logo.21faa497.png";